import moment, { Moment } from 'moment';

/**
 * Returns a moment object with the correct DST adjustment
 * @param {string} originDate 
 * @param {string} currentDate 
 * @param {string} time 
 * @returns {Moment}
 */
export const getDateTimeWithDst = (originDate: string, currentDate: string, time: string, originTime: string): Moment => {
    const momentOrigin = getLocalDateTimeFromUtc(originDate, originTime);
    const momentCurrent = getLocalDateTimeFromUtc(currentDate, time);
    if (isDstObserved(momentOrigin) !== isDstObserved(momentCurrent)) { // Checks if the date is in DST
        const adjustment = isDstObserved(momentOrigin) ? 1 : -1; // Add 1 hour if DST is observed, otherwise subtract 1 hour
        return getLocalDateTimeFromUtc(currentDate, time, adjustment); // Adjust the timezone in time to match the DST
    }

    return momentCurrent;
}

/**
 * Gets the local date time from a UTC date string
 * @param {string} utcDate 
 * @param {string} timeWithZone 
 * @param {string} adjustment 
 * @returns {Moment}
 */
const getLocalDateTimeFromUtc = (utcDate: string, timeWithZone: string, adjustment?: number): Moment => {
    let [time, offset] = timeWithZone.split(/(?=[+-])/);
    let adjustedTimeWithTimezone = null;

    if (!offset) {
        console.error('Invalid time zone format');

        return moment(`${moment(utcDate).format('YYYY-MM-DD')}T${timeWithZone}`);
    }

    if (adjustment) {
        let hours = parseInt(offset);
        hours += adjustment;
        adjustedTimeWithTimezone = `${time}${hours >= 0 ? '+' : '-'}${Math.abs(hours) > 9 ? '' : '0'}${hours}`; // Adjust the timezone in time to match the DST
    }

    return moment(`${moment(utcDate).utcOffset(timeWithZone).format('YYYY-MM-DD')}T${adjustedTimeWithTimezone || timeWithZone}`);
};

/**
 * Determines if the date is in DST
 * @param {Moment} date 
 * @returns {boolean}
 */
const isDstObserved = (date: Moment): boolean => {
    const year = moment(date).year();
    const dstOffset = Math.max(moment([year, 0]).utcOffset(), moment([year, 6]).utcOffset()); // Get the maximum offset for the year

    return date.utcOffset() < dstOffset; // If the offset is less than the DST offset, then the date is in DST
};